const title = "众亲网"; //可以在这里直接定义，也可以在一个地方统一设置再在这里引入

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
